import { Link as RouterLink } from "react-router-dom";

import { navigationLinkTypes } from "../../../../Drawer.constants";

import { INavigationItem } from "../../../../Drawer.types";

export const getNavigationLinkProperties = ({ href, linkType }: INavigationItem) => {
  if (linkType === navigationLinkTypes.spaRoute) {
    return { component: RouterLink, to: href };
  }

  if (linkType === navigationLinkTypes.newTab) {
    return { component: "a", href, target: "_blank", rel: "noreferrer" } as const;
  }

  return { component: "a", href } as const;
};
